import React, { useEffect, useState } from 'react';
import C from '../C';
import ServerIO from '../plumbing/ServerIO';
import DataStore from '../base/plumbing/DataStore';
import { space, sum } from '../base/utils/miscutils';
import { getStatus } from '../base/data/DataClass';
import PropControl from '../base/components/PropControl';
import Misc from './MiscOverrides';
import { Col, Row } from 'reactstrap';
import { dateStr, dateUTCfromString } from '../base/utils/date-utils';
/**
 * Currently a copy-paste (and remove) from AdvertPage.jsx
 */


// TODO replace with KSizes? enum
const STANDARD_SIZES = {
	mpu : [300,250],
	mpu2: [300, 600],
	billboard : [970, 250],
	leaderboard : [728, 90],
	responsive: [500, 500]
};

// pixel sizes of ad creatives (found via inspector)
const CREATIVE_SIZES = {
	mpu: [210, 175],
	mpu2: [207, 417],
	billboard : [676, 172],
	leaderboard : [434, 60],
};

function SizeToggle({size, advert, inline, displayPath, curSize}) {
	const onSizeToggle = ({value}) => {
		if(!value) return;
		DataStore.setValue(displayPath.concat("displaySize"), size);
	};

	return <PropControl label={size} type="checkbox" checked={size===curSize} path={["widget", "DisplayAd"]} prop={size} inline={inline} saveFn={onSizeToggle} />;
}

function PreviewDisplayAd({advert, size, path, selectable, className, onClick, curSize, inCol}) {
	const [cacheBuster, setCacheBuster] = useState(0);
	const [loading, setLoading] = useState(true);

	// Copied from SavePublishDeleteEtc
	let localStatus = DataStore.getLocalEditsStatus(C.TYPES.Advert, advert.id) || C.STATUS.clean;
	let isdirty = C.STATUS.isdirty(localStatus) || C.STATUS.issaveerror(localStatus);
	
	useEffect(() => {
		if (isdirty) setLoading(true);
		else reload();
	}, [isdirty]);

	if (!size) {
		return <><Misc.Loading /><h3>No ad format set!</h3></>;
	}

	let [width, height] = STANDARD_SIZES[size];

	const reload = () => {
		setCacheBuster(cacheBuster + 1);
		setLoading(true);
	};

	/*
	// Cheap reloading for live - TODO make a proper injection script
	useEffect(() => {
		reload();
	}, [advert]);
	*/

	let sizeStr = "";
	if (size && size !== "responsive") {
		sizeStr += '&width="'+STANDARD_SIZES[size][0]+'"';
		sizeStr += '&height="'+STANDARD_SIZES[size][1]+'"';
		sizeStr += '&size='+size+'';
	}
	// ensure ads is scaled down to take up at least 85% of remaining space, 
	let scale = Math.min(1, 9 * screen.width / (20 * STANDARD_SIZES[size][0]));
	
	let displayAdUrl = `${ServerIO.AS_ENDPOINT}/display/${advert.id}/index.html?status=DRAFT&demoNumber=${actionCount({advert})}&cachebuster=${cacheBuster}${sizeStr}`;
	console.log([...path, "advanced"], "<------");
	return <div className={space("preview-container", className, size)}>
		<div className={space('displayad-preview', size)}>
			<iframe src={displayAdUrl} onLoad={() => setLoading(false)} className="preview-frame" title={size+'-preview'} width={width} height={height} style={{transform:`scale(${scale})`}}/>
			<div className="preview-controls">
				{selectable ? <SizeToggle curSize={curSize} size={size} displayPath={[...path, "displayBase"]} advert={advert} inline /> : <div/>}
				<a className={space('refresh', loading && "loading")} role="button" onClick={reload}>Refresh <img src="/img/refresh.png"/></a>
			</div>
			{loading && <div className="loading"><h3>Loading...</h3></div>}
			{onClick && <a className="clickable" onClick={onClick} role="button"/>}
			{scale < 1 && <p>{`Advert is previewing at ${parseInt(scale.toFixed(2) * 100) /* 0.ABCD -> AB% */}% size to allow it to fit onto the screen.`}</p>}
		</div>
	</div>;
}

/** Given a set of impressions & debits for an advert, find how many actions have been completed
 *  Currently only gives a preset 0 as unsure on...
 *		- Do we want this to live update as impressions increase,
		- OR do we want to set this to # of actions committed to?

		- Impact debits don't always have this value - they should but it's not guaranteed, how do we handle these cases
		- Ads can have multiple impact debits, all with different actions - how do we handle that?
		- AFAIK, impactDebits are on campaigns, not ads. Does this matter for this use case?
 * 
 * @param {*} param0 
 * @returns 
 */
function actionCount({advert, path, impressions, impactDebits, useDemoNumber=false}) {
	if(useDemoNumber) return DataStore.getValue([...path, 'advanced', 'demoNumber']) || 1000;
}


function previewCol({ad, path}) {
	let size = ad.displayBase.displaySize;

	return (
		<Col className="preview-col">
			<div className='previewInfo'>
				<Col>
					<h2>{`${ad.name || "unnamed"} ${ad.displayBase.isTemplate ? "Template" : "Advert"}`}</h2>
					<Row>
						{ad.created ? <p>Created: {dateStr(dateUTCfromString(ad.created))}</p> : <p>Created: not published yet</p>}
						{ad.lastModified && <p>Last modified: {dateStr(dateUTCfromString(ad.lastModified))}</p>}
					</Row>
					<Row>
						{ad.serving && <p>Ad currently serving</p>}
						{ad.hasServed && <p>Ad previously served</p>}
					</Row>
				</Col>
			</div>
			<PreviewDisplayAd advert={ad} size={size} path={path} className="sticky-preview" />
		</Col>
	);
}


export {PreviewDisplayAd, actionCount, SizeToggle, STANDARD_SIZES, CREATIVE_SIZES, previewCol};
